<template>
  <van-form class="container setting-page" @submit="onSubmit">
    <div class="container zx-fill-ticket-info inenr-container">
      <div class="header f-s-b">
        <div class="info-image-box f-c">
          <van-image
            class="info-image"
            lazy-load
            :src="contactsInfo.image"
            fit="scale-down"
          />
        </div>
        <div v-if="isBindUserInfo" class="user-name g-b-500">
          {{ contactsInfo.name }}
        </div>
        <div v-if="isBindUserInfo" class="user-tips">
          欢迎您 {{ getUserInfo.isVolunteer === 1 ? "志愿者" : "普通用户" }}
        </div>
      </div>

      <div class="body">
        <ul class="body-rander-item explain-home-info-input">
          <li class="row-box">
            <van-field
              class="item-row f-s-b user-name"
              v-model.trim="contactsInfo.name"
              :disabled="isBindUserInfo"
              clearable
              :name="`name`"
              :border="false"
              label="姓名"
              placeholder="请输入用户姓名"
              :rules="[{ message: ' ', validator: checkName }]"
            />
            <i v-if="false" class="iconfont iconjiantouarrow487 icon-size"></i>
          </li>
          <li class="row-box phone-box">
            <van-field
              class="item-row f-s-b user-name"
              v-model.trim="contactsInfo.phone"
              :disabled="isBindUserInfo"
              type="tel"
              clearable
              maxlength="11"
              name="phone"
              :border="false"
              label="手机号码"
              placeholder="请输入用户手机号"
              :rules="[{ required: true, message: ' ', validator: checkPhone }]"
            />
            <!-- <div v-if="isBindUserInfo" class="change-phone f-c" v-touch:tap="goToChangePhone">修改号码</div> -->
            <!-- <i class="iconfont iconjiantouarrow487 icon-size"></i> -->
          </li>

          <li class="row-box pwd-box">
            <van-field
              v-model.trim="contactsInfo.pwd"
              class="item-row f-s-b user-name"
              type="password"
              label="密码"
              clearable
              name="pwd"
              placeholder="请输入密码"
              maxlength="18"
              :rules="[{ pwdPattern, message: ' ' }]"
            />
            <li class="row-box pwd-box">
            <van-field
              class="item-row f-s-b user-name second_pwdIpt"
              v-model.trim="confirm_pwd"
              type="password"
              clearable
              maxlength="18"
              name="pwd"
              :border="false"
              label="再次输入"
              placeholder="请输入密码"
              :rules="[{ validator:confirmIsSame, message: '密码不一致' }]"
            />
          </li>
          </li>
        </ul>
      </div>

      <div class="foot f-c" v-if="isBindUserInfo === false">
        <!-- <div class="foot f-c"> -->
        <van-button class="btn f-c" block type="info" native-type="submit">
          保存
        </van-button>
      </div>
    </div>

    <div hidden style="width: 0; height: 0">{{ getUserInfo }}</div>
  </van-form>
</template>

<script>
import util from "@util";
import { Field, Form, Button } from "vant";
import http from "@js/http-zyz.js";
import {
  updateUserInfoUrl,
  sendSMSVerifyCodeUrl,
  getInfoByOpenIdUrl,
  getUserInfoByOpenId,
} from "@url";
export default {
  data() {
    return {
      btnFlag: true,
      btnTxt: "获取验证码",
      phonePattern: /^1[3456789]\d{9}$/,
      pwdPattern: /^[a-z0-9_-]{6,18}$/,
      idPattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
      contactsInfo: {
        // image: require('@image/personalCenter/user-head.png'),
        image: require("@image/personalCenter/chanegImage/111.png"),
        name: "",
        // id: "",
        phone: "",
        code: "",
        pwd: "",
        // name: '路哥',
        // id: '510109198712211234',
        // phone: '15928176933',
      },
      confirm_pwd: "",
    };
  },
  created() {
    var timeCount = sessionStorage.getItem("code-count");
    if (timeCount) {
      this.codeBtnCount(Number(timeCount));
    }
    const { type = "" } = this.$route.query;
    if (type === "volunteer") {
      window.document.title = "志愿者信息";
    }
  },
  methods: {
    onSubmit(values) {
      if (values) {
        // this.$router.push({ name: 'volunteerSuccess'})
        var data = {
          // openId: this.getOpenId,
          phone: this.contactsInfo.phone,
          userName: this.contactsInfo.name,
          passWord: this.contactsInfo.pwd,
        };
        this.commitData(data);
      }
    },
    commitData(data) {
      http
        .post(updateUserInfoUrl, { ...data })
        .then(({ data: { data: userInfo = {} } }) => {
          console.log(data);
          this.$toast("保存成功");
          this.$store.commit("setUserInnerInfo", userInfo);
          this.$store.commit("setUserId", userInfo.userId);
        });
    },
    codeBtnCount(size = 59) {
      this.btnFlag = false;
      var time = setInterval(() => {
        this.btnTxt = `${size}秒后重试`;
        size--;
        sessionStorage.setItem("code-count", size);
        if (size === 0) {
          clearInterval(time);
          this.btnTxt = "获取验证码";
          this.btnFlag = true;
          sessionStorage.removeItem("code-count");
        }
      }, 1000); //  记得改成 1000
    },
    getCode() {
      if (this.phonePattern.test(this.contactsInfo.phone)) {
        if (this.btnFlag) {
          this.codeBtnCount();
          this.sendCode();
        }
      } else {
        this.$toast("请正确填写手机号码");
      }
    },
    sendCode() {
      http
        .post(sendSMSVerifyCodeUrl, {
          phone: this.contactsInfo.phone,
        })
        .then((res) => {
          console.log(res);
          var {
            data: {
              success = false,
              data: { verifyCode: code },
            },
          } = res;
          if (success) {
            this.$toast.success("短信发送成功 请注意查收");
          } else {
            this.$toast.fail("短信发送失败 请稍后再试");
          }
        });
      ``;
    },
    confirmIsSame(v) {
      return this.contactsInfo.pwd === v;
    },
    checkName(v) {
      return /^[\u4e00-\u9fa5_a-zA-Z]{2,10}$/.test(v);
    },
    checkPhone(v) {
      // return this.phonePattern.test(v)
      return new Promise((resolve) => {
        this.$toast.loading({
          forbidClick: true,
          message: "验证中...",
        });
        setTimeout(() => {
          this.$toast.clear();
          resolve(this.phonePattern.test(v));
        }, 700);
      });
    },
    checkPassword(v) {
      return /^[a-z0-9_-]{6,18}$/.test(v);
    },
    checkId(v) {
      return this.idPattern.test(v);
    },
    checkCode(v) {
      return /^[0-9]{6}$/.test(v);
    },
    goToChangePhone() {
      this.$router.push("changePhone");
    },
  },
  computed: {
    //  判断当前用户是否绑定 来对应渲染页面
    isBindUserInfo() {
      return false;
      //   return this.$store.state.userInfo.isBind || false;
    },
    getOpenId() {
      return this.$store.state.userInfo.openId || "";
    },
    getUserInfo() {
      var info = this.$store.state.userInfo.info || false;
      if (info) {
        this.contactsInfo.name = info.userName;
        this.contactsInfo.phone = info.phone;
        // this.contactsInfo.id = info.idcard;
      }
      return info;
    },
  },
  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [Button.name]: Button,
  },
};
</script>

<style lang="less" scoped>
.red-box {
  border: 1px solid red;
}

.f-s-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.f-c {
  display: flex;
  align-items: center;
  justify-content: center;
}
.inenr-container {
  padding: 7px;
}
.container {
  // height: ~"calc(100% - 50px)" !important;
  // padding-bottom: 50px;
  .header {
    padding: 20px 0;
    margin-bottom: 10px;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 3px 1px 6px 0px rgba(224, 224, 224, 0.5);
    background-color: rgba(255, 255, 255, 1);
    flex-direction: column;
    font-size: 12px;
    color: #bebebe;
    .info-image-box {
      .info-image {
        width: 70px;
        height: 70px;
        border-radius: 100%;
        background: #fefdf5;
        box-shadow: 0 0.08rem 0.26667rem 0 rgba(232, 190, 129, 0.52);
      }
      .user-leave {
        margin-left: 12px;
      }
    }
    .info-active {
      transform: translateX(30px);
    }
    .user-name {
      font-size: 20px;
      color: #343434;
      margin: 10px 0 5px;
    }
  }

  .body {
    margin-bottom: 10px;
    // padding: 7px;
    .body-rander-item {
      background-color: #ffffff;
      overflow: hidden;
      border-radius: 5px;
      box-shadow: 3px 1px 6px 0px rgba(224, 224, 224, 0.5);
      margin-bottom: 7px;
      .row-box {
        overflow: hidden;
        position: relative;
        box-sizing: border-box;
        height: 50px;
        padding: 0 12px;
        background-color: #ffffff;
        &:last-child {
          .item-row {
            border: 0;
          }
        }
        .icon-size {
          font-weight: 500;
          color: #9599a2;
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
        .item-row {
          border-bottom: 0.5px solid #cbcbcb;
          height: 100%;
          background-color: transparent;
          font-size: 14px;
        }
        .right-control {
          color: #9599a2;
          position: absolute;
          top: 50%;
          overflow: hidden;
          transform: translateY(-50%);
          left: 90px;
          right: 12px;
          .icon-size {
            &::before {
              font-weight: 500;
            }
          }
        }
        .number-control {
          justify-content: flex-start;
          .number-box {
            margin: 0 10px;
            display: inline-flex;
            vertical-align: top;
            width: 65px;
            height: 22px;
            box-sizing: border-box;
            border: 1px solid rgba(212, 212, 212, 1);
          }
          .number-icon-size {
            &::before {
              font-size: 20px;
              font-weight: 500;
            }
          }
        }
      }
      .phone-box {
        .change-phone {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(255, 255, 255, 1);
          border-radius: 5px;
          color: #9aa2b7;
          font-size: 13px;
          border-radius: 11px;
          border: 1px solid rgba(213, 213, 213, 1);
          padding: 5px 10px;
          z-index: 5;
        }
      }
      .code-box {
        padding-left: 90px;
        .code-btn {
          width: 84px;
          height: 23px;
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translateY(-50%);
          font-size: 13px;
          color: #9aa2b7;
          border-radius: 11px;
          background-color: #ffffff;
          border: 1px solid rgba(213, 213, 213, 1);
        }
      }
      .info-row {
        padding-top: 10px;
        padding-bottom: 10px;
        align-items: baseline;
        height: auto;
        justify-content: flex-start;
        font-size: 12px;
        color: #979899;
        .left-txt {
          margin-left: 12px;
          width: 80px;
          text-align-last: justify;
          color: #61666c;
          font-weight: 500;
        }
        .right-txt {
          width: ~"calc(100% - 85px)";
        }
      }
      .info-title {
        padding-left: 0;
        padding-right: 0;
        margin: 0 12px;
        border-bottom: 0.5px solid #cccccc;

        align-items: baseline;
        justify-content: space-between;
        .inner-row {
          align-items: baseline;
        }
        .info-left {
          max-width: ~"calc(100% - 120px)";
          font-size: 14px;
          font-weight: 500;
          color: rgba(67, 68, 70, 1);
          .icon-size {
            margin-right: 10px;
            height: 20px;
            box-sizing: border-box;
            &::before {
              font-size: 20px;
              display: inline-block;
              vertical-align: top;
            }
          }
        }
        .info-right {
          font-size: 14px;
          display: block;
          max-width: 130px;
          .count {
            font-size: 17px;
            margin-left: 3px;
          }
        }
      }
    }
    .body-container {
      position: relative;
      border-radius: 5px;
      overflow: hidden;
      box-shadow: 3px 1px 6px 0px rgba(224, 224, 224, 0.5);
      background-size: 118px 142px;
      background-repeat: no-repeat;
      background-position: right 70%;
      background-image: url("../../lib/image/home/567.png");
      background-color: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      width: 100%;
      padding: 14px 30px;
      font-size: 12px;
      color: #565656;
      height: auto;
      & {
        .item:last-child {
          margin: 0;
        }
      }
      .title {
        text-align: center;
        color: #242424;
        font-size: 16px;
      }
      .small-title {
        font-size: 14px;
        color: #565656;
      }
      .body-iamge {
        width: 100%;
        margin: 10px 0;
      }
      .item {
        margin-bottom: 10px;
      }
      .time {
        padding-left: 9px;
        letter-spacing: 1px;
      }
    }
    .contacts-title-box {
      padding-left: 12px;
      height: 50px;
      font-size: 14px;
      color: #555555;
      // justify-content: flex-start;
      .icon-size {
        margin-right: 5px;
        &::before {
          // font-size: 22px;
        }
      }
      .look-narrators {
        border: 0;
        padding: 3px 6px;
        font-size: 15px;
        color: rgba(255, 255, 255, 1);
        background: rgba(92, 162, 253, 1);
        border-radius: 3px;
      }
    }
  }

  .foot {
    background-color: #f0f1f4;
    // right: 0;
    padding: 0 14px;
    height: 40px;
    .btn {
      border: 0;
      font-size: 15px;
      color: rgba(255, 255, 255, 1);
      width: 100%;
      height: 100%;
      // background:rgba(92,162,253,1);
      border-radius: 120px;
      background: linear-gradient(157deg, #ffa300 0%, #ff3f36 100%);
    }
  }

  .language-box {
    box-sizing: border-box;
    padding: 50px;
    flex-direction: column;
    .language {
      width: 100%;
    }
    .language-row {
      width: 100%;
      height: 40px;
    }
  }
}
</style>